export default  [
  {
    key: "id",
    label: "#",
  },
  {
    key: "owner_name",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract_name",
    label: "Contract",
    sortable: true
  },

  {
    key: "device_name",
    label: "Device",
    sortable: true
  },

  {
    key: "device_plate",
    label: "Plate Number",
    sortable: true
  },


  {
    key: "day",
    label: "Date",
    sortable: true
  },

  {
    key: "first_ignition_start",
    label: "ignition on",
    sortable: true
  },

  {
    key: "last_ignition_close",
    label: "ignition off",
    sortable: true
  },

  {
    key: "ignition_work_duration",
    label: "ignition on duration",
    sortable: true
  },

  {
    key: "ignition_close_duration",
    label: "ignition off duration",
    sortable: true
  },

  {
    key: "idle_duration",
    label: "idle duration",
    sortable: true
  },

  {
    key: "max_speed_kmh",
    label: "max speed",
    sortable: true
  },

  {
    key: "route_length_km",
    label: "distance",
    sortable: true
  },


]